import { ActionList, ActionListItem, ActionListItemIcon, Button, ChevronDownIcon, Dropdown, DropdownButton, DropdownOverlay, RupeeIcon, Tooltip, XCircleIcon } from "@razorpay/blade/components";

interface VPFButtonsProps {
  shouldManageVPF: boolean;
  isVPFDisabled: boolean;
  onVPFOptIn: () => void;
  onVPFOptOut: () => void;
}

export const VPFButtons = ({
  shouldManageVPF,
  isVPFDisabled,
  onVPFOptIn,
  onVPFOptOut,
}: VPFButtonsProps) => {
  const buttons = shouldManageVPF ? (
    <Dropdown>
      <DropdownButton
        variant="tertiary"
        isDisabled={isVPFDisabled}
        icon={ChevronDownIcon}
        iconPosition="right">
        Manage VPF
      </DropdownButton>
      <DropdownOverlay>
        <ActionList>
          <ActionListItem
            title="Modify VPF amount"
            value="modify"
            leading={<ActionListItemIcon icon={RupeeIcon} />}
            onClick={onVPFOptIn}
          />
          <ActionListItem
            title="Opt out of VPF"
            value="optout"
            leading={<ActionListItemIcon icon={XCircleIcon} />}
            intent="negative"
            onClick={onVPFOptOut}
          />
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  ) : (
    <Button variant="tertiary" isDisabled={isVPFDisabled} onClick={onVPFOptIn}>
      Opt In to VPF
    </Button>
  );

  if (isVPFDisabled) {
    return (
      <Tooltip
        content={
          'VPF configuration is disabled by your organisation. Contact admin for further details.'
        }>
        {buttons}
      </Tooltip>
    );
  }

  return buttons;
};